/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PinterestAccountSettings_userSocialNetwork = {|
  +serviceId?: ?string;
  +status?: ?string;
  +pinterest?: ?{|
    +boards: ?$ReadOnlyArray<?{|
      +name: ?string;
      +url: ?string;
    |}>;
  |};
  +userPreferences?: ?{|
    +board: ?string;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PinterestAccountSettings_userSocialNetwork",
  "selections": [
    {
      "kind": "InlineFragment",
      "type": "PinterestSocialNetwork",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PinterestConnectBoardModal_userSocialNetwork",
          "args": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "serviceId",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "status",
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Pinterest",
          "name": "pinterest",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "PinterestBoard",
              "name": "boards",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "name",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "PinterestSocialNetworkUserPreferencesType",
          "name": "userPreferences",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "board",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "UserSocialNetwork"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./assets/js/global/components/Pinterest/__generated__/PinterestAccountSettings_userSocialNetwork.graphql.js